import React, { useState } from 'react';

/**
 * Official Facebook video embed using the plugin iframe.
 * Works for videos, reels, and share URLs when they resolve to public posts.
 * Docs: https://developers.facebook.com/docs/plugins/embedded-video-player/
 */
export default function FacebookEmbed({ url, title }) {
  const [loaded, setLoaded] = useState(false);
  if (!url) return null;

  const src = `https://www.facebook.com/plugins/video.php?href=${encodeURIComponent(
    url
  )}&show_text=false&width=560&t=0`;

  return (
    <div className="facebook-embed-wrapper relative bg-black rounded-md overflow-hidden">
      <div className="aspect-video">
        {!loaded && (
          <div className="absolute inset-0 bg-slate-100 animate-pulse flex items-center justify-center text-slate-400 text-xs">
            Loading Facebook video…
          </div>
        )}
        <iframe
          src={src}
          title={title || 'Facebook video'}
          className="w-full h-full"
          style={{ border: 'none', overflow: 'hidden' }}
          scrolling="no"
          frameBorder="0"
          allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
          allowFullScreen
          loading="lazy"
          onLoad={() => setLoaded(true)}
        />
      </div>
    </div>
  );
}
